import { Badge } from '@mui/material'
import { FC, useMemo } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { getConfig } from '../../utils/appHelpers'
import { BadgeLabel } from '../modals/AboutBiomarker'

const Body = styled.div`
  
`
const HealthStatusText = styled.p`
  color: var(--text-main, #1a1a1a);
  margin-top: -10px;
  display: inline-block;
  /* Header/M */
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px; /* 177.778% */
  letter-spacing: 0.36px;
  padding: 0;
  margin: 0;
  margin-right: 10px;
  margin-top: -15px;
    MARGIN-BOTTOM: -15px;
`

const BadStatus = styled.span`
  color: var(--red-50, #d83f3d);
  font-weight: 600;

  padding: 4px 12px;
  border-radius: 100px;
  border: 1px solid var(--red-20, #f8d1cc);
  background: var(--red-10, #fcecea);
`

const Optimal = styled.span`
  color: var(--primary-50, #218b8f);
  font-weight: 600;

  padding: 4px 12px;
  border-radius: 100px;
  border: 1px solid var(--primary-20, #c2eaed);
  background: var(--primary-10, #e8f4f1);
`

type StatusPropsT = { text?: string; status?: 'optimal' | 'bad' }
type HealthStatusProps = { status?: string; isScoreMissing?: boolean }

export const Status: FC<StatusPropsT> = ({ status = 'bad', text }) => {
  switch (status) {
    case 'optimal':
      return <Optimal>{text}</Optimal>
    case 'bad':
      return <BadStatus>{text}</BadStatus>
    default:
      return <></>
  }
}

const toLocalizedString = (value: any, lang: string): string => {
  if (value == null) return '';
  if (typeof value === 'string') return value;
  if (typeof value === 'object' && !Array.isArray(value)) {
    const code = lang?.slice(0, 2) || 'en';
    return (value[code] ?? value.en ?? value.de ?? (Object.values(value)[0] as string)) ?? '';
  }
  return String(value);
};

export const ConfigText = (props: any) => {
  const { i18n } = useTranslation();
  const { field, children } = props || {};
  const raw = getConfig(field, children);
  const __html = toLocalizedString(raw, i18n.language);
  return <div dangerouslySetInnerHTML={{ __html }} className={'configText '} data-field={field} />;
};
const NeutralStatus = styled.span`
  color: #9e9e9e;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 100px;
  border: 1px solid #d9d9d9;
  background: #f5f5f5;
  text-transform: lowercase;
`
const HealthStatus: FC<HealthStatusProps> = ({ status = 'R', isScoreMissing = false}) => {
    const { t } = useTranslation()
    console.log("qqqqq statusssss", status);
  return (
    <Body>
      <HealthStatusText>
        <ConfigText field={'holistic_health_status'}>{t('holisticHealthStatus')}</ConfigText>
      </HealthStatusText>
      {isScoreMissing ? (
        <NeutralStatus>n.a.</NeutralStatus>
      ) : (
      <BadgeLabel scaleValue={status}></BadgeLabel>
      )}
      <div></div>
    </Body>
  )
}

export default HealthStatus
